export function matchCSSObject(arg) {
    return (arg instanceof Object &&
        !('styles' in arg) &&
        !('length' in arg) &&
        !('__emotion_styles' in arg));
}
